import * as React from "react";

function SvgPlusInCircle(props) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}><circle cx={12} cy={12} r={12} fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M13.0083 7.00449V10.9763H16.9955C18.3348 10.9763 18.3348 13.0083 16.9955 13.0083H13.0083V16.9955C13.0083 18.3348 10.9763 18.3348 10.9763 16.9955V13.0083H7.00449C5.66517 13.0083 5.66517 10.9763 7.00449 10.9763H10.9763V7.00449C10.9763 5.66517 13.0083 5.66517 13.0083 7.00449Z" fill="#fff" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/plus-in-circle_7073e1.svg";
export { SvgPlusInCircle as ReactComponent };